import { useRef } from 'react';

// 拍题/拍作答通用上传：选图 → FileReader dataURL → ≤5MB 校验 → 预览
export default function ImageUpload({
  dataUrl,
  onLoaded,
  label = '上传图片',
}: {
  dataUrl: string;
  onLoaded: (dataUrl: string) => void;
  label?: string;
}) {
  const ref = useRef<HTMLInputElement>(null);

  const pick = (file: File | undefined) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      alert('图片不能超过 5MB，请压缩后重试');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => onLoaded(String(reader.result));
    reader.readAsDataURL(file);
  };

  return (
    <div>
      <input
        ref={ref}
        type="file"
        accept="image/png,image/jpeg,image/webp"
        className="absolute w-px h-px opacity-0"
        onChange={(e) => {
          pick(e.target.files?.[0]);
          e.target.value = '';
        }}
      />
      {dataUrl ? (
        <div className="relative">
          <img src={dataUrl} alt="预览" className="max-h-72 w-auto rounded-lg border border-gray-200" />
          <button
            type="button"
            onClick={() => ref.current?.click()}
            className="mt-2 text-sm text-brand-600 underline"
          >
            重新选择
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => ref.current?.click()}
          className="w-full rounded-xl border-2 border-dashed border-gray-300 py-10 text-sm text-gray-500 hover:border-brand-400 hover:text-brand-600"
        >
          📷 {label}（png/jpg/webp，≤5MB）
        </button>
      )}
    </div>
  );
}
